import Vue from 'vue'
import confirm from '@/components/confirmation-modal/confirm.vue'
export default Vue.extend({
  name: 'TemporaryComplete',
  components: {
    confirm
  }
})
